/**
 * Merge locally-created names (items the user just created via the dropdown's
 * "Create" popup in this session) with server-fetched names, de-duplicate
 * case-insensitively, apply the current search filter, and preserve "local
 * first" ordering.
 *
 * Shared by AttributeMappingTable and AttributeValueMappingTable so the
 * dropdown list always surfaces items the user just created, even before
 * the backend's dropdown-options endpoint has indexed the new Neo4j node.
 *
 * @param locallyCreated Names created in this session. Shown first in the
 *        merged list regardless of the server response.
 * @param serverFetched  Names returned by the backend's dropdown endpoint
 *        for the current page/search.
 * @param search         Active search term. Results are filtered
 *        case-insensitively by substring.
 * @returns Unique list of names (local first, then server), empty strings
 *          dropped, case-insensitive-deduped.
 */
export const mergeMappedOptions = (
    locallyCreated: string[],
    serverFetched: string[],
    search: string,
): string[] => {
    const seen = new Set<string>();
    const s = (search || '').toLowerCase();
    const result: string[] = [];

    for (const name of [...locallyCreated, ...serverFetched]) {
        if (!name) continue;
        const lower = name.toLowerCase();
        if (seen.has(lower)) continue;
        seen.add(lower);
        if (s && !lower.includes(s)) continue;
        result.push(name);
    }

    return result;
};
